// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "rqx-training.firebaseapp.com",
  "databaseURL": "https://rqx-training.firebaseio.com",
  "projectId": "rqx-training",
  "storageBucket": "rqx-training.appspot.com",
  "messagingSenderId": "332249300287",
  "appId": "1:332249300287:web:dd26ef6eadaed8e1",
  "apiKey": "AIzaSyDuKq9GbZg1Y6P3nHZN99c5JoRZYPXZ6Ik"
};
